import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { makeStyles } from 'tss-react/mui';

import {
  businessOverview,
  euroLandWidgets,
} from '@lumirental/lumi-web-shared/lib/constants/IR/content';

import DynamicContent from '@/company/IR/blocks/DynamicContent/DynamicContent';
import EuroLandWidget from '@/company/IR/blocks/EuroLandWidget/EuroLandWidget';

import styles from '@/company/IR/blocks/Overview/OverviewBlock.style';

const useStyles = makeStyles()(styles);

export default function OverviewBlock() {
  const { classes } = useStyles();

  return (
    <Grid
      container
      columnSpacing={{ xs: 0, sm: 11 }}
      direction="row"
      sx={{
        alignItems: 'center',
      }}
    >
      <Grid item xs={12} sm={5}>
        <DynamicContent content={businessOverview} />
      </Grid>
      <Grid item xs={12} sm={7}>
        <Box className={classes.overviewBorder}>
          <EuroLandWidget
            id="tickerChart"
            widgetSrc={euroLandWidgets.tickerChart.link}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
